export const handleMaps = (address, latitude, longitude) => {
  const encodedAddress = encodeURIComponent(address);
  const encodedLatitude = encodeURIComponent(latitude);
  const encodedLongitude = encodeURIComponent(longitude);

  // Google Maps web URL
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&center=${encodedLatitude},${encodedLongitude}`;

  // Open in new browser tab
  window.open(googleMapsUrl, '_blank');
};